import {
    BadgeDollarSign,
    Building2,
    CircleUserRound,
    CreditCard,
    FileText,
    HandHeart,
    LockKeyhole,
    type LucideIcon,
    NotepadText,
    Receipt,
    Video,
} from 'lucide-react';

import type { PracticeAccessSource } from '@nesso/practice-contracts/practice-access-rule.access-sources';

type SettingsNavRoute =
    | '/settings/profile'
    | '/settings/notes'
    | '/settings/security'
    | '/settings/billing-settings'
    | '/settings/billing-documents'
    | '/settings/online-payments'
    | '/settings/services'
    | '/settings/practice-details'
    | '/settings/telehealth'
    | '/settings/plan-billing';

export type SettingsNavGroup = {
    label: string;
    items: {
        label: string;
        to: SettingsNavRoute;
        icon: LucideIcon;
        requiredAccessSources?: PracticeAccessSource[];
    }[];
};

export const settingsNavGroups: SettingsNavGroup[] = [
    {
        label: 'Account Settings',
        items: [
            {
                label: 'Profile',
                to: '/settings/profile',
                icon: CircleUserRound,
            },
            {
                label: 'Notes',
                to: '/settings/notes',
                icon: NotepadText,
            },
            {
                label: 'Security',
                to: '/settings/security',
                icon: LockKeyhole,
            },
        ],
    },
    {
        label: 'Portal and Scheduling',
        items: [
            {
                label: 'Telehealth',
                to: '/settings/telehealth',
                icon: Video,
                requiredAccessSources: ['CLINICIAN', 'EHR_BASE'],
            },
        ],
    },
    {
        label: 'Client Billing',
        items: [
            {
                label: 'Services',
                to: '/settings/services',
                icon: HandHeart,
                requiredAccessSources: ['CLINICIAN', 'EHR_BASE'],
            },
            {
                label: 'Billing settings',
                to: '/settings/billing-settings',
                icon: BadgeDollarSign,
                requiredAccessSources: ['CLINICIAN', 'EHR_BASE'],
            },
            {
                label: 'Billing documents',
                to: '/settings/billing-documents',
                icon: FileText,
                requiredAccessSources: ['CLINICIAN', 'EHR_BASE'],
            },
            {
                label: 'Online payments',
                to: '/settings/online-payments',
                icon: Receipt,
                requiredAccessSources: ['OWNER', 'EHR_BASE'],
            },
        ],
    },
    {
        label: 'Practice Settings',
        items: [
            {
                label: 'Practice details',
                to: '/settings/practice-details',
                icon: Building2,
                requiredAccessSources: ['CLINICIAN', 'EHR_BASE'],
            },
            {
                label: 'Nesso plan',
                to: '/settings/plan-billing',
                icon: CreditCard,
            },
        ],
    },
];
